export const BRAND_MAPPING = {
    'Aunt Fannies': "Aunt Fannie's",
    'Angels Eyes': "Angels' Eyes",
    'Ben & Jerrys': "BEN & JERRY'S",
    'Beggin Strips': "Beggin' Strips",
    'Bocces Bakery': "Bocce's Bakery",
    Browns: "Brown's",
    'Burts Bees': "Burt's Bees",
    Dentleys: "Dentley's",
    'Dr Seuss The Cat in the Hat': "Dr Seuss' The Cat in the Hat",
    'Dr. Elseys': "Dr. Elsey's",
    'Egglands Best': "Eggland's Best",
    Flukers: "Fluker's",
    'Flys Off': "Fly's Off",
    'Hills Prescription Diet': "Hill's Prescription Diet",
    'Hills Science Diet': "Hill's Science Diet",
    'Kit N Kaboodle': "Kit 'N Kaboodle",
    'Kruses Perfection Brand': "Kruse's Perfection Brand",
    Lafebers: "Lafeber's",
    'Maxs Closet': "Max's Closet",
    'Millers Forge': "Miller's Forge",
    'Natures Animals': "Nature's Animals",
    'Natures Miracle': "Nature's Miracle",
    'Natures Ocean': "Nature's Ocean",
    'Natures Protection': "Nature's Protection",
    'Natures Recipe': "Nature's Recipe",
    'Natures Variety Instinct': "Nature's Variety Instinct",
    'Skouts Honor': "Skout's Honor",
    'Vets Best': "Vet's Best",
    Wackywalkr: "WACKYwalk'r",
    'Worlds Best': "World's Best",
};

export const getMappedBrandName = (brand: string) => {
    const mappedBrand = BRAND_MAPPING[brand as keyof typeof BRAND_MAPPING];
    return mappedBrand ?? brand;
};
